interface IConfig {
    AppUrl(): string;
    ApiUrl(): string;
    UserAgent: string;
    confirmDeleteClassName: string;
}
class Config implements IConfig {
    AppUrl(): string {
        return "/";
    }
    ApiUrl(): string {
        return "/api/";
    } 
    UserAgent = "GPOIdentityServer";
    confirmDeleteClassName = "confirmalert";
}
export {Config,IConfig}
